import React, { Component } from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Divider,
  Chip,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  ExpandMore,
  Refresh,
  TrendingUp,
  StopTwoTone,
} from "@mui/icons-material";
import { apiSlaveList, apiAutoActionCloseOrder } from "../../Service/api";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Toaster, toast } from "react-hot-toast";

const len = (x) => (Array.isArray(x) ? x.length : 0);

const defaultFilterMethod = (filter, row) => {
  const raw = row[filter.id];
  const cellValue =
    raw === null || raw === undefined ? "" : String(raw).toLowerCase();
  const query = (filter.value || "").toLowerCase();
  return cellValue.includes(query);
};

class ConfirmDialog extends Component {
  render() {
    const {
      open,
      title,
      description,
      onClose,
      onConfirm,
      confirmText = "Confirm",
    } = this.props;
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="contained">
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

class SetTPDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { tp: "" };
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ tp: "" });
    }
  }
  handleConfirm = () => {
    const { onConfirm } = this.props;
    const { tp } = this.state;
    if (onConfirm) onConfirm(tp);
  };
  render() {
    const { open, onClose, accountNumber } = this.props;
    const { tp } = this.state;
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 700 }}>Set Take Profit</DialogTitle>
        <DialogContent>
          <Stack spacing={1.5} sx={{ mt: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
              Account: <strong>{accountNumber || "-"}</strong>
            </Typography>
            <TextField
              label="TP Value"
              type="number"
              value={tp}
              onChange={(e) => this.setState({ tp: e.target.value })}
              placeholder="e.g. 2000"
              fullWidth
              inputProps={{ inputMode: "decimal", step: "any" }}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={this.handleConfirm}
            variant="contained"
            disabled={tp === ""}
          >
            Set TP
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

class MasterSlaveListPage extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      tableData: [],
      expanded: null,
      loginInfo: "",
      actionContext: { account_number: null, market: null },
      dialog: {
        closeBuy: false,
        closeSell: false,
        closeAll: false,
        setTP: false,
      },
      globalSearch: "",
      secretKey:
        "e69902f8ca7bf37cb776f323384f502205cb907e8935c118faf6803e239402d6",
    };
    this.tableColumns = [];
  }

  componentDidMount() {
    this.doLoadData();
    let loginInfo = localStorage.getItem("loginInfo");
    try {
      loginInfo = JSON.parse(loginInfo);
    } catch {
      loginInfo = {};
    }
    this.setState({ loginInfo: loginInfo || {} });
    window.scrollTo(0, 0);
  }

  callLoading = () => {
    if (this.props && typeof this.props.doLoading === "function") {
      this.props.doLoading();
    }
  };

  doLoadData = () => {
    this.callLoading();
    apiSlaveList()
      .then((res) => {
        this.callLoading();
        const data = res.data;
        if (data.records && data.records.length) {
          const dataArr = [].concat(data.records);
          for (let i = 0; i < dataArr.length; i++) {
            const record = dataArr[i];
            const arr = record.infoSlave || [];
            for (let j = 0; j < arr.length; j++) {
              const info = arr[j];
              info.status =
                info.buy === record.buy && info.sell === record.sell;
            }
          }
          dataArr.sort((a, b) => len(b.infoSlave) - len(a.infoSlave));
          this.setState({ tableData: dataArr });
        } else {
          this.setState({ tableData: [] });
        }
      })
      .catch((err) => {
        this.callLoading();
        console.error(err);
        toast.error("Failed to load data");
      });
  };

  generateRandomHex = (length) => {
    return [...Array(length)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join("");
  };

  doActionOrder = (payload, messageToast) => {
    this.callLoading();
    apiAutoActionCloseOrder(payload)
      .then((res) => {
        this.callLoading();
        this.doLoadData();
        toast.success(messageToast);
      })
      .catch((err) => {
        this.callLoading();
        console.error(err);
        toast.error(`Failed to perform action order: ${err.message}`);
      });
  };

  pressReset = () => {
    this.setState({ tableData: [] }, this.doLoadData);
  };

  handleExpand = (key) => {
    this.setState((prev) => ({ expanded: key === prev.expanded ? null : key }));
  };

  openAction = (type, account_number, market) => {
    this.setState((prev) => {
      const nextDialog = { ...prev.dialog, [type]: true };
      return { actionContext: { account_number, market }, dialog: nextDialog };
    });
  };

  closeAction = (type) => {
    this.setState((prev) => {
      const nextDialog = { ...prev.dialog, [type]: false };
      return { dialog: nextDialog };
    });
  };

  showToast = (ok, text) => {
    if (ok) toast.success(text, { duration: 2000 });
    else toast.error(text, { duration: 2000 });
  };

  confirmCloseBuy = () => {
    const { account_number } = this.state.actionContext;
    this.closeAction("closeBuy");
    const payload = {
      category: "CLOSE ORDER BUY",
      subCategory: "",
      ticket_id: this.generateRandomHex(16),
      secretKey: this.state.secretKey,
      data: {
        account_id: account_number,
        client_id: this.state.loginInfo.phoneno,
        executor: this.state.loginInfo.name,
        note: "",
      },
    };
    const messageToast = `Close Order Buy sent for ${account_number}.`;
    this.doActionOrder(payload, messageToast);
  };

  confirmCloseSell = () => {
    const { account_number } = this.state.actionContext;
    this.closeAction("closeSell");
    const payload = {
      category: "CLOSE ORDER SELL",
      subCategory: "",
      ticket_id: this.generateRandomHex(16),
      secretKey: this.state.secretKey,
      data: {
        account_id: account_number,
        client_id: this.state.loginInfo.phoneno,
        executor: this.state.loginInfo.name,
        note: "",
      },
    };
    const messageToast = `Close Order Sell sent for ${account_number}.`;
    this.doActionOrder(payload, messageToast);
  };

  confirmCloseAll = () => {
    const { account_number } = this.state.actionContext;
    this.closeAction("closeAll");
    const payload = {
      category: "CLOSE ORDER ALL",
      subCategory: "",
      ticket_id: this.generateRandomHex(16),
      secretKey: this.state.secretKey,
      data: {
        account_id: account_number,
        client_id: this.state.loginInfo.phoneno,
        executor: this.state.loginInfo.name,
        note: "",
      },
    };
    const messageToast = `Close Order All sent for ${account_number}.`;
    this.doActionOrder(payload, messageToast);
  };

  confirmSetTP = (tpValue) => {
    const { account_number } = this.state.actionContext;
    this.closeAction("setTP");

    const payload = {
      category: "SET TP",
      subCategory: "",
      ticket_id: this.generateRandomHex(16),
      secretKey: this.state.secretKey,
      data: {
        account_id: account_number,
        client_id: this.state.loginInfo.phoneno,
        executor: this.state.loginInfo.name,
        note: `Set Take Profit ${tpValue}`,
        take_profit: tpValue,
      },
    };

    const messageToast = `Set TP ${tpValue} sent for ${account_number}.`;
    this.doActionOrder(payload, messageToast);
  };

  renderTable = (master) => {
    const dataList = master.infoSlave || [];
    const columns = [
      {
        Header: "VPS",
        accessor: "vps",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            sx={{
              color:
                e.original.status === false ? "error.main" : "text.primary",
              fontWeight: 600,
            }}
          >
            {e.original.vps}
          </Typography>
        ),
      },
      {
        Header: "Account",
        accessor: "account_number",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            sx={{
              color:
                e.original.status === false ? "error.main" : "text.primary",
              fontWeight: 500,
            }}
          >
            {e.original.account_number}
          </Typography>
        ),
      },
      {
        Header: "Buy",
        accessor: "buy",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            sx={{
              color:
                e.original.status === false ? "error.main" : "text.primary",
            }}
          >
            {parseInt(e.original.buy, 10)}
          </Typography>
        ),
      },
      {
        Header: "Sell",
        accessor: "sell",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            sx={{
              color:
                e.original.status === false ? "error.main" : "text.primary",
            }}
          >
            {parseInt(e.original.sell, 10)}
          </Typography>
        ),
      },
    ];

    const needle = (this.state.globalSearch || "").toLowerCase();
    const filteredList =
      needle.length === 0
        ? dataList
        : dataList.filter((r) =>
            (
              (r.vps || "") +
              "|" +
              (r.account_number || "") +
              "|" +
              (r.buy || "") +
              "|" +
              (r.sell || "")
            )
              .toLowerCase()
              .includes(needle)
          );

    return (
      <Box sx={{ width: "100%" }}>
        <ReactTable
          ref={(r) => (this.reactTable = r)}
          data={filteredList}
          columns={columns}
          className="-striped -highlight"
          filterable
          defaultFilterMethod={defaultFilterMethod}
          defaultPageSize={
            filteredList.length > 0 && filteredList.length < 100
              ? 100
              : filteredList.length < 0
              ? 0
              : filteredList.length
          }
          showPageJump={false}
          showPageSizeOptions={false}
          showPagination={false}
          style={{ overflow: "hidden" }}
        />
      </Box>
    );
  };

  renderList = () => {
    const { tableData } = this.state;
    const groupedData = {};
    for (let i = 0; i < tableData.length; i++) {
      const obj = tableData[i];
      const key = obj.market;
      if (!groupedData[key]) groupedData[key] = [];
      groupedData[key].push(obj);
    }

    const markets = Object.keys(groupedData);
    if (markets.length === 0) {
      return (
        <Paper sx={{ p: 3, borderRadius: 3 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            No data available
          </Typography>
        </Paper>
      );
    }

    return (
      <Stack spacing={3}>
        {markets.map((market) => {
          const accounts = groupedData[market];
          return (
            <Paper
              key={market}
              elevation={0}
              sx={{
                p: { xs: 1, md: 1 },
                borderRadius: 3,
                backgroundColor: "rgba(255,255,255,0.1)",
                boxShadow: "none",
              }}
            >
              <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "stretch", md: "center" }}
                justifyContent="space-between"
                spacing={1.25}
                sx={{ mb: 1 }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  flexWrap="wrap"
                >
                  <Typography variant="h6" fontWeight={800}>
                    {market}
                  </Typography>
                  <Chip
                    label={accounts.length + " Master"}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                </Stack>
              </Stack>
              <Divider sx={{ mb: { xs: 1, md: 2 } }} />

              <Stack spacing={1.25}>
                {accounts.map((obj) => {
                  const headKey = String(obj.account_number);
                  return (
                    <Accordion
                      key={headKey}
                      onChange={() => this.handleExpand(headKey)}
                      expanded={this.state.expanded === headKey}
                      sx={{
                        borderRadius: 2,
                        "&:before": { display: "none" },
                        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                        mb: 1,
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontWeight: 800,
                                fontSize: { xs: 14.5, md: 16 },
                              }}
                            >
                              {obj.account_number +
                                (obj.alias ? ` (${obj.alias})` : "")}
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <Stack
                              direction="row"
                              spacing={0.75}
                              flexWrap="wrap"
                            >
                              <Chip
                                size="small"
                                label={`Buy ${obj.buy}`}
                                color="success"
                                variant="outlined"
                                sx={{ height: 22 }}
                              />
                              <Chip
                                size="small"
                                label={`Sell ${obj.sell}`}
                                color="warning"
                                variant="outlined"
                                sx={{ height: 22 }}
                              />
                              {this.state.expanded === headKey && (
                                <Chip
                                  size="small"
                                  label={`${len(obj.infoSlave)} Accounts`}
                                  color="info"
                                  variant="outlined"
                                  sx={{ height: 22 }}
                                />
                              )}
                            </Stack>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid container spacing={0.75}>
                              <Grid item xs={6} md="auto">
                                <Button
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  color="success"
                                  startIcon={<StopTwoTone />}
                                  sx={{ minHeight: 34, fontSize: 12, px: 1.25 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.openAction(
                                      "closeBuy",
                                      obj.account_number,
                                      obj.market
                                    );
                                  }}
                                >
                                  Close Buy
                                </Button>
                              </Grid>
                              <Grid item xs={6} md="auto">
                                <Button
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  color="error"
                                  startIcon={<StopTwoTone />}
                                  sx={{ minHeight: 34, fontSize: 12, px: 1.25 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.openAction(
                                      "closeSell",
                                      obj.account_number,
                                      obj.market
                                    );
                                  }}
                                >
                                  Close Sell
                                </Button>
                              </Grid>
                              <Grid item xs={6} md="auto">
                                <Button
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  startIcon={<StopTwoTone />}
                                  sx={{ minHeight: 34, fontSize: 12, px: 1.25 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.openAction(
                                      "closeAll",
                                      obj.account_number,
                                      obj.market
                                    );
                                  }}
                                >
                                  Close All
                                </Button>
                              </Grid>
                              <Grid item xs={6} md="auto">
                                <Button
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  color="secondary"
                                  startIcon={<TrendingUp />}
                                  sx={{ minHeight: 34, fontSize: 12, px: 1.25 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.openAction(
                                      "setTP",
                                      obj.account_number,
                                      obj.market
                                    );
                                  }}
                                >
                                  Set TP
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </AccordionSummary>

                      <AccordionDetails sx={{ pt: 0.5, pb: { xs: 1, md: 2 } }}>
                        {this.renderTable(obj)}
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </Stack>
            </Paper>
          );
        })}
      </Stack>
    );
  };

  render() {
    const { dialog, actionContext } = this.state;
    return (
      <Box>
        <Box sx={{ flexGrow: 1, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography
                      component="span"
                      variant="h1"
                      style={{
                        fontSize: 20,
                        color: "#000",
                        fontWeight: "bold",
                      }}
                    >
                      Master Slave List
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 0 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{ backgroundColor: "#1273DE" }}
                          startIcon={<Refresh />}
                          onClick={this.pressReset}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {this.renderList()}

        <ConfirmDialog
          open={dialog.closeBuy}
          title="Close Order Buy"
          description={`Send close BUY for master ${
            actionContext.account_number || "-"
          }?`}
          onClose={() => this.closeAction("closeBuy")}
          onConfirm={this.confirmCloseBuy}
          confirmText="Close Buy"
        />
        <ConfirmDialog
          open={dialog.closeSell}
          title="Close Order Sell"
          description={`Send close SELL for master ${
            actionContext.account_number || "-"
          }?`}
          onClose={() => this.closeAction("closeSell")}
          onConfirm={this.confirmCloseSell}
          confirmText="Close Sell"
        />
        <ConfirmDialog
          open={dialog.closeAll}
          title="Close All Orders"
          description={`Send close ALL orders for master ${
            actionContext.account_number || "-"
          }?`}
          onClose={() => this.closeAction("closeAll")}
          onConfirm={this.confirmCloseAll}
          confirmText="Close All"
        />
        <SetTPDialog
          open={dialog.setTP}
          onClose={() => this.closeAction("setTP")}
          accountNumber={actionContext.account_number}
          onConfirm={this.confirmSetTP}
        />

        <Toaster position="top-right" />
      </Box>
    );
  }
}

export default MasterSlaveListPage;
